import { useCallback, useState } from "react";
/**
 * Shared helper for the common "set loading, call an async fn, surface
 * errors" pattern used by the taskpane's action handlers.
 */
export function useAsyncAction() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const run = useCallback(async (fn, onError) => {
        setLoading(true);
        setError(null);
        try {
            const result = await fn();
            return result;
        }
        catch (err) {
            const handled = onError === null || onError === void 0 ? void 0 : onError(err);
            if (!handled) {
                const msg = err instanceof Error
                    ? err.message
                    : typeof err === "string"
                        ? err
                        : `Unexpected error: ${JSON.stringify(err)}`;
                setError(msg);
            }
            return undefined;
        }
        finally {
            setLoading(false);
        }
    }, []);
    return { run, loading, error, setError };
}
